import axios from "axios";

// export const url = 'https://evantage.ddns.net:80/cmms_kpj_dev2';
export default axios.create({
  baseURL: "https://evantage.ddns.net:80/React_webwork/api",
  //baseURL: "http://192.168.0.26:8080/React_webwork/api",
  //baseURL: "https://evantage-cmms.com.my:80/webwork/api",
  //  baseURL: 'https://evantage-cmms.com.my/webwork/Api',
  // baseURL: 'http://192.168.0.34:8080/cmms_kpj_dev/',
  // baseURL: 'http://localhost:8080/cmms_kpj_dev'
  headers: {
    "Content-type": "application/json",
  },
});

// standard
// "homepage": "https://evantage.ddns.net:80/React_webwork",

// ktmb
// "homepage": "https://evantage-cmms.com.my/webwork/",
